<template>
  <div  v-show="kpi"
        v-bind:class="{ pihead1: isHeader && showInlineYtd, pihead2: isHeader && !showInlineYtd && !isStandalone, piheadtop: isStandalone, 'compress-horizontally': compressHorizontally }">
    <div  class="pihead ppgrid"
          :style="{ 'background': flipArrowColor ? '#444' : ' transparent' }"
          v-bind:class="getWaveCountDependentGridClass(minorWaveCount)"> <!-- minor wave count 3..5 styles!!! -->
      <div  v-for="index in minorWaveCount"
            v-bind:key="index"
            v-bind:style="getBackgroundStyle(index)"
            class="perf-cell">
        <div class="perf-block">
          <div class="perf-head left">{{ getSlotName(index) }}</div>
          <div class="perf-value">{{ getSlotValue(index) }}</div>
        </div>
      </div>
      <div>
        <div v-bind:style="getBackgroundStyle(101)">
          <div class="perf-head left" v-bind:class="{ narrow: false }">{{ getSlotName(101) }}</div>
          <div class="bc-highlight">{{ getSlotValue(101) }}</div>
        </div>
      </div>
      <div v-bind:style="getBackgroundStyle(101)">
        <div class="image">
          <span href="#" :class="{ 'black': !flipArrowColor, 'no-black': flipArrowColor }">
            <font-awesome-icon v-if="getArrow === 2" icon="arrow-up" item-width="24" item-height="36" />
            <font-awesome-icon v-if="getArrow === 3" icon="arrow-down" item-width="24" item-height="36" />
            <font-awesome-icon v-if="getArrow === 1" icon="arrow-right" item-width="24" item-height="36" />
          </span>
        </div>
      </div>
      <div class="ytdgrid tiny" v-bind:style="{ 'color': showInlineYtd ? '#F2F2F2' : 'black' }">
        <ytd-item :showInlineYtd="showInlineYtd" :ytd="getYtdItem(kpi, -2)" />
        <ytd-item :showInlineYtd="showInlineYtd" :ytd="getYtdItem(kpi, -1)" />
      </div>
    </div>
  </div>
</template>

<script>
  import YtdItem from './YtdItem.vue';
  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import thresholdMixin from '@/mixins/ThresholdColor-APP_TARGET';
  import PerformanceItemMixin from '@/mixins/bmw/PerformanceItemMixin.js';
  
  export default {
    mixins: [ ytdMixin, thresholdMixin, PerformanceItemMixin ],

    components: {
      YtdItem
    },

    props:{
      compressHorizontally: { type: Boolean, required: false, default: false },
      flipArrowColor: { type: Boolean, required: false, default: false },
      thresholds: { type: Array, required: true }
    },

    methods:{
      getSlotName: function(slot) {
        let it = this.getSlot(slot)
        if (it === undefined || it.Result === undefined || it.Name === undefined) 
          return ''
        else if (!this.showPrewaves && !_.has(it, "ResultPromoters")) 
          return '';
        
        return this.getShortName(it);
      },

      getShortName(item) {
        let name = item.Name; 
        if (name.startsWith(item.Year.toString())) 
          name = name.substring(2);
        name = name.replace('_', '');
        return name;
      },

      getYtdItem(kpi, invIndex) {
        return kpi && kpi.YTD
          ? _.nth(kpi.YTD, invIndex)
          : undefined;
      },
      
      isFloat(n){
          return Number(n) === n && n % 1 !== 0;
      },

      getBackgroundStyle(index) {
        if (!this.monochrome) {
          let value = this.getSlotValue(index);
          if (value || value === 0) {
            let col = this.getThresholdColor(this.thresholds, value, '#fff');
            return { 'background-color': col };
          }
        } else {
          return {'background-color' : '#F2F2F2'}
        }
        // intentionally do not set a bg color
      },

      getBackgroundForIndicator: function (index) {
        if (this.monochrome || this.kpi === null || this.kpi.SurveyWave === null) {
          return {'background-color' : '#F2F2F2'}
        }

        let col = this.getThresholdColor(
          this.thresholds, this.kpi.SurveyWave[index].Result, '#fff');
        return { 'background-color': col };
      },

      getWaveCountDependentGridClass(count) {
        switch (count) {
          case 5: // 6 Waves selected
            return {'ppgrid6' : true}

          case 4: // 5 Waves selected
            return {'ppgrid5' : true}

          default: // up to 4 Waves
            return {'ppgrid' : true}
        }
      }
    },

    computed: {
      showSecondYTD() {
        return !(!this.kpi || !this.kpi.YTD || this.kpi.YTD.length < 1);
      },
      showFirstYTD() {
        return !(!this.kpi || !this.kpi.YTD || this.kpi.YTD.length < 2);
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "@/../scss/bmw/performanceitem.scss";

.compress-horizontally {
  width: max-content !important;
}

.ytdval {
  padding-inline-start: 2px;
  font-size: 9pt;
  text-align: left;
}
.ytdgrid {
  display: grid;
  grid-template-rows: 1fr 1fr;
}
.ppgrid, .ppgrid5, .ppgrid6, .perf-block {
  display: grid;
  height: 36px;
}
.ppgrid {
  grid-template-columns: 2fr 2fr 2fr 2.5fr 0.75fr 3.75fr;
}

.ppgrid5 {
  grid-template-columns: 2fr 2fr 2fr 2fr 3.333fr 1fr 5fr;
}

.ppgrid6 {
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 4.166fr 1.25fr 6.25fr;
}

.image {
  top: 14px;
  right: 2px;
}

.piheadtop {
  margin-top: 0px;
}

.pihead1 {
  width: 16pc;
}

.bc-highlight {
  font-size: 14pt;
  text-align: center;
  line-height: 20px;
  margin-left: 0px;
  margin-top: 0px;
  top: -2px;
}

</style>
